export const PROJECT_STATUSES = ["presupuestado", "en_obra", "pausado", "terminado", "cerrado", "cancelado"];
export const MOVEMENT_TYPES = ["anticipo", "gasto"];
export const PAYMENT_METHODS = ["efectivo", "transferencia", "tarjeta", "cheque"];

const STATUS_TONE = {
  presupuestado: "gray",
  en_obra: "amber",
  pausado: "gray",
  terminado: "green",
  cerrado: "green",
  cancelado: "gray",
};

export const projectStatusTone = (s) => STATUS_TONE[s] || "gray";

export const ALLOWED_TRANSITIONS = {
  presupuestado: ["en_obra", "cancelado"],
  en_obra: ["pausado", "terminado", "cancelado"],
  pausado: ["en_obra", "cancelado"],
  terminado: ["cerrado"],
  cerrado: [],
  cancelado: [],
};

export const MOTIVO_REQUIRED = ["pausado", "cancelado"];

export const transitionLabelKey = (origen, destino) => {
  if (destino === "en_obra") return origen === "pausado" ? "resume" : "start";
  return { pausado: "pause", terminado: "finish", cerrado: "close", cancelado: "cancel" }[destino] || destino;
};
